import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmComponent } from '../../../components/catalogue/shared/confirm/confirm.component';

@Injectable({
  providedIn: 'root',
})
export class CommonDataService {
  public loaderStatus = new Subject<boolean>();

  userData: any = {};

  constructor(private http: HttpClient, private modalService: NgbModal) {}

  setLoader = (val) => {
    this.loaderStatus.next(val);
  };

  convertToString = (obj) => {
    return _.cloneDeepWith(obj, (value) => {
      return !_.isPlainObject(value) ? _.toString(value) : undefined;
    });
  };

  public confirm(message: string, dialogSize: string): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmComponent, {
      size: dialogSize,
    });
    modalRef.componentInstance.message = message;

    return modalRef.result;
  }
}
